import React from 'react';

export const Logo = ({ className = "h-12 w-auto" }) => {
  return (
    <img 
      src="/logo-acrobatisseur.png" 
      alt="AcrobaTisseur - Expert en travaux acrobatiques"
      className={className}
    />
  );
};

export const LogoIcon = ({ size = 40 }) => {
  return (
    <img 
      src="/logo-acrobatisseur.png" 
      alt="AT" 
      style={{ width: size, height: size }}
      className="rounded-lg"
    />
  );
};
